// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { DataType } from '../interfaces/interfaces';

export function getValueFromString(stringValue, dataType) {
    switch (dataType) {
        case DataType.string: {
            return stringValue.trim();
        }
        case DataType.bool: {
            return getBool(stringValue);
        }
        case DataType.int: {
            return getNumber(stringValue);
        }
        default: {
            return false;
        }
    }
}

export function getBool(stringValue) {
    switch (stringValue) {
        case 'true':
        case 'TRUE': {
            return true;
        }
        default: {
            return false;
        }
    }
}

export function getNumber(stringValue?: string): number {
    const num = Number(stringValue);
    return isNaN(num) ? 0 : num;
}
